module.exports = __webpack_public_path__ + "img/6.a32709f8.jpg";